<script>
import ieVerify from '@/views/cargo/v0/Integrated/ieVerify'

export default {
  name: 'TTIEVerify',
  extends: ieVerify,
  props: {
    integratedLogisticsType: {
      type: String,
      default: 'TT' // 设置默认值
    }
  }
}
</script>
